import React from 'react';

const hasError = ({ errors, touched, name }) => errors[name] && touched[name];

const Error = ({ text }) => <div className="help-block">{text}</div>;

const ErrorMessage = ({ errors, touched, name }) =>
  hasError({ errors, touched, name }) ? <Error text={errors[name]} /> : null;

export { Error };
export default ErrorMessage;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/parts/EnquireForm/ErrorMessage.js